export default {"src":"/_next/static/media/briefcase-white.28500185.svg","height":52,"width":52};